"use client";

import { ArrowLeftIcon } from "lucide-react";

import { useRouter } from "@/i18n/navigation";
import { Button } from "@workspace/ui/components/button";

import { resolveBackNavigation } from "./not-found-recovery";

export const NotFoundBackButton = ({
  fallbackHref,
  label,
}: {
  fallbackHref: string;
  label: string;
}) => {
  const router = useRouter();

  return (
    <Button
      onClick={() => {
        const { useHistory } = resolveBackNavigation({
          historyLength: window.history.length,
          origin: window.location.origin,
          referrer: document.referrer === "" ? null : document.referrer,
        });

        if (useHistory) {
          router.back();
          return;
        }

        router.push(fallbackHref);
      }}
      type="button"
      variant="ghost"
    >
      <ArrowLeftIcon aria-hidden="true" data-icon="inline-start" />
      {label}
    </Button>
  );
};
